import { Button, Typography } from "@carrotfertility/carotene-core"
import React from "react"

export function SeeAvailabilityPage({ onContinue }: { onContinue: () => void }): JSX.Element {
  return (
    <>
      <Typography>This is the See availability page</Typography>
      <Button onClick={onContinue}>Continue</Button>
    </>
  )
}
